import { wrapSyncFunc } from '../util';
export var minLength = wrapSyncFunc(function (rule, value) {
  var minLength = rule.minLength,
      _rule$minLengthType = rule.minLengthType,
      minLengthType = _rule$minLengthType === void 0 ? 'char' : _rule$minLengthType;

  if (minLength == null) {
    return;
  }

  if (typeof value === 'string' && value !== '') {
    var str = 'byte' === minLengthType ? value.replace(/[^\x00-\xff]/g, '01') : value;
    return str.length >= +minLength;
  }
});